import { render, staticRenderFns } from "./LessonsList.vue?vue&type=template&id=8782ed82&scoped=true"
import script from "./LessonsList.vue?vue&type=script&lang=js"
export * from "./LessonsList.vue?vue&type=script&lang=js"
import style0 from "./LessonsList.vue?vue&type=style&index=0&id=8782ed82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8782ed82",
  null
  
)

export default component.exports